export function hasDirtyFields(value: unknown): boolean {
    if (value === true) {
        return true;
    }

    if (!value || typeof value !== 'object') {
        return false;
    }

    if (Array.isArray(value)) {
        return value.some(hasDirtyFields);
    }

    return Object.values(value).some(hasDirtyFields);
}
